// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2riP6","header":"PatientBlock_header__35WyB","label":"PatientBlock_label__SCQpO","option":"PatientBlock_option__vu9YN"};